<template>
  <div class="page-course-detail" v-show="isShow && isMounted">
    <div class="left-right-content clearfix">
      <el-breadcrumb class="add-breadcrumb" separator="/">
        <el-breadcrumb-item ><a :href="baseUrl+'/nAnimateMake?plate='+videoDetail.belongSection">动画制作</a></el-breadcrumb-item>
        <el-breadcrumb-item ><a :href="baseUrl+'/course?plate='+videoDetail.belongSection">课程</a></el-breadcrumb-item>
        <el-breadcrumb-item>点播</el-breadcrumb-item>
        <!--<el-breadcrumb-item>课程类型</el-breadcrumb-item>-->
      </el-breadcrumb>
      <div class="c-left">
        <div class="top-info">
          <div
            class="video-wrap"
            :style="{backgroundImage: 'url(' + videoDetail.courseThumbnail +')'}"
          >
            <el-button class="mask-all" v-if="courseStatus !='1' " @click="showTag(0)"></el-button>
            <el-button class="mask-all" v-else-if="!isLogin" @click="showTag(1)"></el-button>
            <el-button class="mask-all" v-else-if="isLogin && loginUserId!=course.creatorId && course.verifyStatus !=2" @click="showTag(3)"></el-button>
            <el-button class="mask-all" v-else-if="isLogin && course.isSignUp !=1 && loginUserId!=course.creatorId" @click="showTag(2)"></el-button>
            <el-button class="mask-all" v-else @click="toView"></el-button>

<!--            <router-link to="" class="mask-all"></router-link>-->
          </div>
          <div class="infoma">
            <div class="tit-jj">
              <div class="tit">{{videoDetail.courseName}}</div>
              <div class="jianjie">{{videoDetail.courseIntroduction}}</div>
            </div>
            <div class="more-info">
              <div class="type" v-if="videoDetail.cType">课程类型：{{videoDetail.cType}}</div>
              <div class="type" v-else>课程类型：{{videoDetail.fType}}</div>
              <div class="much">{{videoDetail.memberCount}}人报名</div>
            </div>
            <div>
              <div v-if="videoDetail.isPromotionTime!= -1">
                <div class="price"><span v-if=" videoDetail.promotionPrice > 0 ">￥{{videoDetail.promotionPrice}}</span><span v-else>免费</span><span class="old-price">￥{{videoDetail.coursePrice}}</span></div>
                <div class="acti-time">活动时间：{{videoDetail.promotionStartTimeStr}} -- {{videoDetail.promotionEndTimeStr}}</div>
              </div>
              <div v-else>
                <div class="price"><span v-if=" videoDetail.coursePrice > 0 ">￥{{videoDetail.coursePrice}}</span><span v-else>免费</span></div>
              </div>

            </div>
            <div class="btns">
              <el-button size="large" class="btn wgz-btn" v-if="!isLogin" @click="toLog">登录</el-button> <!--  -->
              <el-button size="large" class="btn wgz-btn" v-else-if="isLogin && loginUserId!=course.creatorId && course.verifyStatus !=2">暂未发布</el-button>
              <el-button size="large" class="btn wgz-btn" v-else-if="isLogin && course.isSignUp !=1 && loginUserId!=course.creatorId" @click="signUp"><span v-if="priceNow >0">立即报名</span><span v-else>观看</span></el-button>
              <el-button size="large" class="btn wgz-btn" v-else @click="toView">观看</el-button>
              <el-button size="large" class="btn" type="success" v-if="!isLogin && course.coursePrice > 0" @click="dashang">付费观看</el-button>
              <!-- <el-button size="large" class="btn" type="warning">在线咨询</el-button> -->
            </div>
          </div>
        </div>
        <div class="course-detail" ref="lessonItemOne">
          <div class="title">课程详情</div>
          <div class="detail-cont">{{videoDetail.mainContent}}</div>
        </div>

        <!-- 评论 -->
        <div class="pro-work-item clearfix" style="border-top: 5px solid #f6f6f6;" ref="lessonItemThree">
        <div class="item-infoes same-left">
        <talkPart :objType="7" :objId="objId" v-if="isReload  && isMounted"
                  :loadShow="true" :isOperate="false" :isHeaderOperate="true"
                  ref="talkPart"></talkPart>
        </div>
        </div>
        <!-- 评论 -->

      </div>
      <div class="c-right">
        <div class="one-item">
          <div class="detail-userinfo">
            <router-link :to="{path:'/home', query: {userId:userInfo.userId}}" class="avatar-f"><img :src="userInfo.imgUrl" alt=""></router-link>
            <div class="user-name"><router-link :to="{path:'/home', query: {userId:userInfo.userId}}">{{userInfo.userName}}</router-link></div>
            <div class="chenghao">{{userInfo.signature}}</div>
            <div class="btns" v-if="isLogin && userInfo.userId != loginUserId">
              <el-button class="btn wgz-btn" v-if="userInfo.followStatus==0"  @click="doFollow(userInfo.userId)"><i class="el-icon-plus"></i> 关注</el-button>
              <el-button class="btn" v-else-if="userInfo.followStatus==1" @click="undoFollower(userInfo.userId)">已关注</el-button>
              <el-button class="btn" v-else-if="userInfo.followStatus==2" @click="undoFollower(userInfo.userId)">互相关注</el-button>

              <el-button class="btn wgz-btn" v-if="friendStatus == 4"  @click="addFriend()"><i class="el-icon-plus"></i> 加好友</el-button>
              <!--<el-button class="btn" @click="toChart(userInfo.userId)" v-else-if="friendStatus == 2">发消息</el-button>-->
              <el-button class="btn" v-else-if="friendStatus == 1" style="cursor:auto">请求中</el-button>

            </div>
            <ul class="much-list three clearfix">

              <li>
                <span class="tit">课程</span>
                <span class="count">{{userInfo.courseCount}}</span>
              </li>
              <li>
                <span class="tit">报名</span>
                <span class="count">{{userInfo.courseSin}}</span>
              </li>
              <li>
                <span class="tit">点赞</span>
                <span class="count">{{userInfo.courseLike}}</span>
              </li>


              <!--<li>
                <router-link target="_blank" :to="{path:'/home/wenzhang', query: {userId:userInfo.userId}}">
                  <span class="tit">文章</span>
                  <span class="count">{{userInfo.archivesCount}}</span>
                </router-link>
              </li>
              <li>
                <span class="tit">阅读</span>
                <span class="count">{{userInfo.viewCount}}</span>
              </li>
              <li>
                <span class="tit">被赞</span>
                <span class="count">{{userInfo.likeCount}}</span>
              </li>-->
            </ul>
            <div class="qianming">{{userInfo.introduction}}</div>
          </div>
        </div>
        <div class="one-item">
          <div class="one-title">
            其他课程
            <i class="el-icon-refresh-right shuaxin" @click="other"></i>
          </div>
          <div class="works-list">

            <div class="item" v-for="(item,index) in otherVideoList" :key="index">
              <div class="work-img-f">
                <router-link  :to="item.courseSeries == 0 ?'/videodetail?id='+item.id+'&plate='+item.belongSection: '/videoduo?id='+item.id+'&plate='+item.belongSection"  target="_blank" :title="item.courseName">
                  <img :src="item.courseThumbnail" alt="">
                  <div class="mask"><i class="el-icon-video-play play-icon"></i></div>
                </router-link>
              </div>
              <div class="work-title">{{item.courseName}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="付费观看"
      top="40px"
      :before-close="handleClose"
      :visible.sync="attenDialog"
      :width="$store.state.app.device === 'desktop' ? '400px' : '90%'"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div style="margin-top: -20px">
        <p>付费观看，即在未登录状态下付费观看。该付费观看形式为按次数计费，即如果已付费，但刷新了页面，则再进入该页面观看需再次收费！</p>
        <p>注意：</p>
        <p style="color: #ff0000">1.强烈建议不要使用该种方式付费观看，请登录后购买。</p>
        <p>2.一旦扫码付费成功，请不要刷新页面且保持网络通畅，一旦出现刷新页面或断网等极端情况，会使得该次付款无效且无法退款。出现该情况平台概不负责。</p>
        <div style="margin-top: 10px;text-align: center">
          <div style="display: inline-block;width: 100px;">
            <p style="width: 100px;height: 100px;" id="qrcodeImgEl_zfb"></p>
            <p>支付宝</p>
          </div>
          <div style="display: inline-block;width: 100px;margin-left: 40px">
            <p style="width: 100px;height: 100px;" id="qrcodeImgEl_wx"></p>
            <p>微信</p>
          </div>
        </div>
        <p style="text-align: center;"><span v-if=" course.coursePrice > 0 ">￥{{course.coursePrice}}</span><span v-else>免费</span></p>
      </div>
    </el-dialog>
    <ul class="right-side-btns">
      <li @click="scrollItem(0)">课程详情</li>
      <li @click="doShare">分&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;享</li>
      <li @click="scrollItem(2)">评&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;论</li>
    </ul>
  </div>
</template>

<script type="text/ecmascript-6">
  import videoApi from '@/api/video'
  import userInfoApi from '@/api/userInfo'
  import homeApi from '@/api/home'
 import talkPart from '@@/pub/talkpart/talkpart'
  import updateTdk from "@/utils/tdk";
  import {mapState} from "vuex";
  import scrollItemMixin from './minxin'
export default {
  components: {
    talkPart
  },
  mixins: [scrollItemMixin],
  data () {
    return {
      baseUrl:process.env.config.RRDH_HOST,
      headTitle: "title---rrdh",
      headKeywords: "keywords---rrdh",
      headDesc: "description---rrdh",
      isMounted: false, //for control not ssr render

      isShow:false,
      isReload:true,
      isLogin:false,
      loginUserId :0,
      objId:0,
      course:{},
      courseStatus:0,
      otherVideoParam:{
        creatorId:0,
        id:0,
        pageIndex: 1,
        pageSize: 2,
        verifyStatus:'2',
        classificationOf: 13,
      },
      otherVideoList:[],
      otherTotal:0,
      isSignUpParam:{
        userId:0,
        courseId:0,
      },
      userInfo:{},
      friendStatus:-1,
      priceNow: 0, //当前价格

      timer: '',
      WeiXin: {},
      ZhiFuBao: {},
      attenDialog: false
    }
  },
  computed: {
    ...mapState(["videoDetail"])
  },
  tdk() {
    return {
      title: this.headTitle,
      description: this.headDesc,
      keywords: this.headKeywords,
      ssrHeadAddInfo: `<link rel="canonical" href="http://www.renrendonghua.com">`
    };
  },
  serverPrefetch() {
    let id = this.$route.query.id
    if(id){
      this.objId =parseInt(id)
    }
    return this.fetchData();
  },
  // destroyed() {
  //   this.$store.commit("SET_VIDEO_DETAIL", { detail: null });
  // },
  // beforeDestroy() {
  //   clearInterval(this.timer);
  // },
  // beforeMount(){
  //   let id = this.$route.query.id
  //   if(id){
  //     this.objId =parseInt(id)
  //   }
  //
  // },
  mounted() {

    const alreadyIncremented = !!this.videoDetail;

    console.log("===================================",this.videoDetail)
    if (!alreadyIncremented) {
      this.fetchData().then(
              setTimeout(()=> {
                this.initData()
              },1500)
      );
    } else {
      setTimeout(()=> {
        this.initData()
      },1500)
    }
  },
  methods:{
    setSeo() {
      this.headTitle = this.videoDetail.courseName+"——人人动画网【官网】";
      this.headKeywords = this.videoDetail.courseIntroduction;
      let desc = this.videoDetail.mainContent.replace(/<\/?.+?>/g,"").trim()
      this.headDesc =desc.substr(0,150);
    },
    fetchData(){
      this.$loading(true)
      const cookies = this.$ssrContext && this.$ssrContext.cookies
      return this.$store
              .dispatch("FETCH_VIDEO_DETAIL", {
                id: this.$route.query.id
              })
              .finally(() => {
                this.$loading(false);
                this.setSeo()
                updateTdk.call(this);
              });
    },
    initData(){
      let thiss = this
      thiss.course  = thiss.videoDetail

      if(thiss.global.isLogin){
        thiss.loginUserId = thiss.global.userModel.id
        thiss.isLogin = true

        let url = '/rrbi/pay/ifPayed?productId=' + thiss.course.id + '&orderType=2&time=' + new Date().getMilliseconds();
        thiss.$axios.get(url).then(function (result) {
          if (result.data == 1) {
            thiss.course.isSignUp =result.data
          }else{
            //没有支付信息，查看是否有报名信息
            const formData = new FormData() // 创建form对象
            formData.append('userId', thiss.global.userModel.id)
            formData.append('courseId', thiss.course.id)

            videoApi.isSignUp(formData).then(data =>{
              thiss.course.isSignUp =data
              thiss.isShow = true
            })
            //thiss.course.isSignUp =0
          }
          thiss.isShow = true
          thiss.isMounted = true;
        })
      }else{
        thiss.isShow = true
        thiss.isMounted = true;
      }
          //console.log("reCourse====>",reCourse.response)

      thiss.courseStatus = thiss.course.attaVideo.status
      thiss.objId =parseInt(thiss.course.id)
      thiss.isReload = true
      //作者信息
      userInfoApi.select(thiss.course.creatorId).then(reUser => {
        thiss.userInfo = reUser.response
      })
      thiss.other()
      thiss.getPriceNow()
      thiss.getFriendStatus()
    },

    getPriceNow(){
      let thiss = this

      let isPromotionTime = thiss.course.isPromotionTime
      let price = 0;

      //-1代表活动结束或者没有活动,不做时间区间验证
      if(isPromotionTime != -1){
        let now = new Date().getTime();
        let sT = new Date(thiss.course.promotionStartTime).getTime()
        let eT = new Date(thiss.course.promotionEndTime).getTime()
        if(sT< now && eT > now){
          isPromotionTime = 1
        }else if(sT > now){
          isPromotionTime = 0
        }else{
          isPromotionTime = -1
        }
      }
      if(isPromotionTime ==0){
        price = thiss.course.coursePrice
      }else{
        if(isPromotionTime==1){
          price = thiss.course.promotionPrice
        }else{
          price = thiss.course.coursePrice
        }
      }

      thiss.priceNow = price
    },
    other(){
      let this_ = this
      this_.otherVideoParam.creatorId =this_.course.creatorId
      this_.otherVideoParam.id = this_.course.id
      videoApi.getOtherList(this_.otherVideoParam).then(reOther => {
        this_.otherVideoList= reOther.list
        this_.otherTotal= reOther.total
        if(this_.otherVideoParam.pageIndex == Math.ceil(this_.otherTotal/this_.otherVideoParam.pageSize) ){
          this_.otherVideoParam.pageIndex =1
        }else{

          this_.otherVideoParam.pageIndex = this_.otherVideoParam.pageIndex+1
        }
      })
    },

    toLog(){
      this.$router.push({
        path:'/login?callback=' + window.location.href,
      })

    } ,
    showTag(type){
      if(type == 0){
        this.$message({
          message: "视频转码中",
          type: 'error'
        });
      }
      if(type == 1){
        this.$message({
          message: "请登录",
          type: 'error'
        });
      }
      if(type == 2){
        if(this.priceNow > 0){
          this.$message({
            message: "请报名",
            type: 'error'
          });
        }else{
          this.signUp()
        }

      }if(type == 3){
        this.$message({
          message: "暂未发布",
          type: 'error'
        });
      }
      return false
    },
    signUp(){
      let _this=this;
      let isPromotionTime = _this.course.isPromotionTime
      let price = 0;

      //-1代表活动结束或者没有活动,不做时间区间验证
      if(isPromotionTime != -1){
        let now = new Date().getTime();
        let sT = new Date(_this.course.promotionStartTime).getTime()
        let eT = new Date(_this.course.promotionEndTime).getTime()
        if(sT< now && eT > now){
          isPromotionTime = 1
        }else if(sT > now){
          isPromotionTime = 0
        }else{
          isPromotionTime = -1
        }
      }


      if(isPromotionTime ==0){
        _this.$confirm('活动未开始，是否确认原价购买？').then(_ => {
          price = _this.course.coursePrice
          _this.toPay(price)
        }).catch(_ => {
          console.log('取消 catch',_)
        })
      }else{
        if(isPromotionTime==1){
          price = _this.course.promotionPrice
        }else{
          price = _this.course.coursePrice
        }
        _this.toPay(price)
      }
    },
    toPay(price){
      let _this=this;
      if(price == '0'){
        let signUpUrl='/rrbi/coursefront/signUp?courseId='+_this.course.id+'&userId='+_this.loginUserId+ '&time='+new Date().getMilliseconds();
        // console.log(signUpUrl)
        _this.$axios.get(signUpUrl).then(function(signResult){
          if(signResult.data.code==1){
            _this.$message({
              message: '报名成功',
              type: 'success'
            });
            _this.toView()
            window.location.reload();
          }else{
            _this.$message({
              message: signResult.data.message,
              type: 'warning'
            });
          }
        })
      }else{
        _this.$router.push({
          path:'/coursepay',
          query: {id:_this.course.id,orderType:2}
        })
      }
    },
    toView(){

      let thiss = this
      if(thiss.courseStatus !=1){
        thiss.$message({
          message: "视频转码中",
          type: 'error'
        });
        return false
      }
      window.open('/videoshow?id='+thiss.course.id+'&plate='+thiss.course.belongSection,"_blank");

    },





    doFollow(userId){
      let this_ = this
      homeApi.follower(userId).then(data => {
        // console.log(data)
        const status = data.response.status
        if (status >= 1) {
          this_.userInfo.followStatus=status
          this_.$message.success("关注成功")
        } else {
          this_.$message.error("关注失败")
        }
      })
    },
    undoFollower(userId) {
      let _this = this;
      homeApi.undoFollower(userId).then(data => {
        // console.log(data)
        const status = data.response.status
        if (status == 1) {
          _this.userInfo.followStatus=0
          _this.$message.success("取消成功")
        } else {
          _this.$message.error("取消失败")
        }
      })
    },
    getFriendStatus(){
      let _this=this;
      let url="/rrbi/friends/getFriendStatus?userId="+_this.course.creatorId+"&currentUserId="+_this.loginUserId+"&ti="+new Date().getMilliseconds();
      _this.$axios.get(url).then(function(result){
        _this.friendStatus = result.data
      })
    },
    addFriend() {
      let _this = this;
      if (_this.global.isLogin) {
        let url = '/rrbi/friends/add/' + _this.course.creatorId + "?ti=" + new Date().getMilliseconds();
        _this.$axios.get(url).then(function (result) {
          // console.log(result)
          if (result.data.response.code == 1) {
            _this.$message.success(result.data.response.msg)
            _this.friendStatus = 1
          } else {
            _this.$message.error(result.data.response.msg)
          }
        })
      }
    },

    handleClose(done) {
      clearInterval(this.timer);
      done()
    },
    dashang () {
      let storage = window.localStorage;
      storage.setItem('storageUserId',new Date().getTime().toString().substr(0,10));
      this.getQRCode(this.course.id)
    },

    getQRCode(id) {
      var _this = this;
      let storage = window.localStorage;
      let url = '/rrbi/pay/getQRCode?payType=0&storageUserId=' + storage.getItem('storageUserId') + '&productId=' + id + '&orderType=-99&time=' + new Date().getMilliseconds();
      _this.$axios.get(url).then(function (result) {
        if (result.data.code == 1) {
          _this.WeiXin = result.data.WeiXin
          _this.ZhiFuBao = result.data.ZhiFuBao

          _this.attenDialog = true

          _this.dashangPay()
        } else {
          _this.$message.error(result.data.message)
        }
      })
    },
    dashangPay() {
      let _this = this
      _this.$nextTick(() => {
        let qrcodeImgEl_zfb = document.getElementById('qrcodeImgEl_zfb')
        let qrcodeImgEl_wx = document.getElementById('qrcodeImgEl_wx')

        qrcodeImgEl_zfb.innerHTML = ''
        let qrcode_zfb = new _this.QRCode(qrcodeImgEl_zfb, {
          width: 100,
          height: 100,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: _this.QRCode.CorrectLevel.H
        })
        qrcode_zfb.makeCode(_this.ZhiFuBao.credential);

        qrcodeImgEl_wx.innerHTML = ''
        let qrcode_wx = new _this.QRCode(qrcodeImgEl_wx, {
          width: 100,
          height: 100,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: _this.QRCode.CorrectLevel.H
        })
        qrcode_wx.makeCode(_this.WeiXin.credential);


        //查询订单是否支付完成
        _this.timer = setInterval(_this.dashangIfPayed, 2000);
      })
    },

    dashangIfPayed() {
      let _this = this;
      let storage = window.localStorage;
      let url = '/rrbi/pay/ifPayed?storageUserId=' + storage.getItem('storageUserId') + '&productId=' + _this.course.id + '&orderType=-99&time=' + new Date().getMilliseconds();
      _this.$axios.get(url).then(function (result) {
        if (result.data == 1) {
          clearInterval(_this.timer);
          _this.$message.success("支付成功")
          //返回详情

          _this.$router.push({
            path: '/dsvideoshow',
            name: 'dsvideoshow',
            params:{//一定要设置name，才可以传params
              courseId: _this.course.id,
            }
          });
          //window.open('/videoshow?id='+_this.course.id,"_blank");
        }
      })
    },
    doShare(){
      this.$refs.talkPart.share();
    }
  }
}
</script>

<style scoped lang="less">
//@import "../../../assets/less/stylePublic.less";
@import "./detail.less";
.page-course-detail {
  padding-top: @NAVHEIGHT;
}
</style>
